export default {
  // AboutPage - 關於我們頁面
  aboutUs: '關於我們',
  aboutUsSubtitle: '一個因旅行而生的故事，一個為愛寵而建的系統',

  ourStory: '我們的故事',
  howItAllBegan: '一切，從一場旅行開始',
  storyParagraph1: '出發前的那個晚上，我們坐在桌前,對著一張密密麻麻的紙發呆。餵食時間、份量、零食限制、每日藥物、獸醫電話、緊急聯絡人⋯⋯要交代照顧者的事情，遠比想像中多得多。即便寫下了滿滿的筆記，心裡依然不踏實——這些細節，照顧者真的都能記住嗎？',
  storyParagraph2: '旅途中，訊息一則接一則：「牠今天要吃幾粒飼料？」「那個藥是早上還是晚上餵？」「牠不肯吃東西，正常嗎？」每一條訊息都讓我們放不下手機，卻又礙於時差與行程，無法即時回應。那份掛念，讓旅行變得不再輕鬆；那份焦慮，也讓照顧者倍感壓力。',
  storyParagraph3: '我們開始想：如果有一個地方，能把愛寵所有的資訊都整理好，讓照顧者隨時查閱，不用猜、不用問、不用擔心記錯——那該多好。於是，這個平台誕生了。專屬於每一隻愛寵，資訊百分百準確，一個連結即可分享。無論是出門旅行，還是將愛寵暫交他人照料,都能真正放心，讓最重要的牠，得到最妥善的照顧。',

  storyHighlight1: '旅行前再也不用手寫密密麻麻的照顧筆記',
  storyHighlight2: '照顧者隨時查閱，減少反覆詢問的困擾',
  storyHighlight3: '資訊百分百準確，主人安心，愛寵得到最好的照顧',
  storyImageCaption1: '每一趟旅行，都能放心出發',
  storyImageCaption2: '牠在家等你，你在外放心',

  founded: '成立年份',
  uniqueStatValue: '獨一無二',
  uniqueStat: '每份檔案專屬訂製',
  alwaysThereValue: '24/7',
  alwaysThere: '牠的資訊，隨時都在',

  ourMission: '我們的使命',
  whyWeExist: '我們存在的理由',
  missionStatement: '我們致力於透過創新科技，讓寵物照護變得更簡單、更精準，幫助每一位寵物主人和照顧者提供最優質的照顧，讓每一隻毛孩都能享受幸福安心的生活。',
  betterCare: '更優質的照護',
  betterCareDesc: '幫助寵物主人提供最專業、最貼心的照顧',
  peaceMind: '安心無憂',
  peaceMindDesc: '讓您隨時掌握愛寵的健康與照護狀況',
  buildCommunity: '建立社群',
  buildCommunityDesc: '連結寵物愛好者與專業照護者',

  ourValues: '我們的價值觀',
  whatDrivesUs: '驅動我們的核心理念',
  valuesDescription: '這些核心價值觀指引著我們的每一個決策與行動。',
  excellence: '追求卓越',
  excellenceDesc: '我們不斷精進服務品質，為用戶提供最佳體驗',
  innovation: '勇於創新',
  innovationDesc: '我們擁抱創新思維，尋找更好的解決方案',
  reliability: '值得信賴',
  reliabilityDesc: '我們提供可靠穩定的服務，讓您安心託付',

  joinOurMission: '加入我們的行列',
  joinMissionDescription: '成為我們社群的一員，一起為寵物照護創造更美好的未來。',
  getStarted: '立即開始',

  // ContactPage
  contactUs: '聯絡我們',
  contactUsSubtitle: '有任何問題或建議嗎？我們很樂意聽取您的意見。',
  technicalSupport: '技術支援',
  homyTechLimited: 'Homy Tech Limited',
  homyTechDescription: '我們是一家專注於寵物科技的創新公司，致力於為寵物主人和照顧者提供最貼心、最專業的數位解決方案。',
  contactByEmail: '透過電子郵件聯絡我們',
  clickToSendEmail: '點擊即可發送郵件，我們會盡快回覆您',
  responseTime: '用心回覆',
  responseTimeDesc: '每一封信都會認真閱讀，我們會盡力在合理時間內給予回覆',
  privacyProtection: '隱私保障',
  privacyProtectionDesc: '您的資料將受到嚴格保護，絕不外洩',
  carefulReply: '真人回覆',
  carefulReplyDesc: '每一封郵件都會由真人仔細閱讀並回覆',
  faq: '常見問題',
  commonQuestions: '常見問題解答',
  faqSubtitle: '這裡有一些最常被問到的問題',
  faq1Question: '如何開始使用這個平台？',
  faq1Answer: '只需要註冊一個免費帳戶，然後建立您的寵物檔案即可。整個過程非常簡單，只需幾分鐘。',
  faq2Question: '我的資料安全嗎？',
  faq2Answer: '絕對安全。我們使用業界標準的加密技術來保護您的資料，並且絕不會將您的個人資訊分享給第三方。',
  faq3Question: '可以分享給多少人？',
  faq3Answer: '您可以將寵物檔案分享給任意數量的照顧者或家人。每個分享連結都是獨立且安全的。',
  faq4Question: '如果忘記密碼怎麼辦？',
  faq4Answer: '在登入頁面點擊「忘記密碼」，輸入您的註冊郵箱，我們會發送重設密碼的連結給您。',
  moreQuestions: '還有其他問題？',
  moreQuestionsDesc: '如果您有任何其他疑問，歡迎隨時透過電子郵件聯絡我們',
  sendEmailNow: '立即發送郵件',

  // SettingsPage
  settingsTitle: '設定',
  settingsDescription: '管理您的帳戶設定和偏好',
  accountSettings: '帳戶設定',
  changePassword: '變更密碼',
  accountInfoSubtitle: '更新您的個人資訊',
  firstName: '名字',
  lastName: '姓氏',
  email: '電子郵件',
  emailPlaceholder: '您的電子郵件',
  emailCannotBeChanged: '電子郵件無法更改',
  phoneNumber: '電話號碼',
  phonePlaceholder: '您的電話號碼',
  saveChanges: '儲存變更',
  saving: '儲存中...',
  changePasswordSubtitle: '更新您的帳戶密碼',
  currentPassword: '目前密碼',
  enterCurrentPassword: '輸入目前密碼',
  newPassword: '新密碼',
  enterNewPassword: '輸入新密碼',
  confirmPassword: '確認密碼',
  confirmNewPassword: '再次輸入新密碼',
  updatePasswordButton: '更新密碼',
  updating: '更新中...',
  passwordRequirements: '密碼要求',
  passwordMinLength: '至少 6 個字元',
  passwordMixCase: '包含大寫字母',
  passwordMismatch: '密碼不相符',
  passwordsMatch: '密碼相符',
  accountUpdated: '帳戶資料已更新',
  passwordUpdated: '密碼已更新',
  fetchError: '載入資料失敗',
  updateError: '更新失敗',
  userNotFound: '找不到用戶',
  currentPasswordRequired: '請輸入目前密碼',
  currentPasswordIncorrect: '目前密碼不正確',
  passwordTooShort: '密碼太短',
  samePasswordError: '新密碼不能與舊密碼相同',
  rateLimitError: '操作過於頻繁，請稍後再試',
  networkError: '網路錯誤，請檢查您的連線',
  logout: '登出',
  logoutToLogin: '登出並回到登入頁',
  loggingOut: '登出中...',
  redirectingToLogin: '正在重新導向至登入頁...',
  refreshingPage: '正在重新整理頁面...',
  loading: '載入中...',

  // PrivacyPage
  privacyPolicyTitle: '隱私權政策',
  privacyPolicySubtitle: '我們重視您的隱私並保護您的個人資訊',
  lastUpdated: '最後更新',
  effectiveDate: '2025年12月20日',
  privacyIntroTitle: '簡介',
  privacyIntro: '本隱私權政策說明我們如何收集、使用和保護您的個人資訊。',
  dataCollectionTitle: '我們收集的資訊',
  dataCollectionDesc: '我們收集以下類型的資訊：',
  personalInfoTitle: '個人資訊',
  personalInfoItem1: '姓名和電子郵件地址',
  personalInfoItem2: '電話號碼（選填）',
  personalInfoItem3: '帳戶憑證',
  petInfoTitle: '寵物資訊',
  petInfoItem1: '寵物名稱、品種、年齡',
  petInfoItem2: '健康記錄和疫苗資訊',
  petInfoItem3: '照護指示和備註',
  petInfoItem4: '寵物照片',
  technicalDataTitle: '技術資料',
  technicalDataItem1: 'IP 位址和瀏覽器資訊',
  technicalDataItem2: '使用模式和偏好',
  technicalDataItem3: 'Cookie 和類似技術',
  dataUsageTitle: '資訊使用方式',
  dataUsageDesc: '我們使用收集的資訊用於：',
  dataUsageItem1: '提供和改進我們的服務',
  dataUsageItem2: '個性化您的體驗',
  dataUsageItem3: '發送重要通知和更新',
  dataUsageItem4: '回應您的詢問',
  dataUsageItem5: '維護平台安全',
  dataUsageItem6: '遵守法律義務',
  dataUsageItem7: '分析和改進服務品質',
  dataSecurityTitle: '資料安全',
  dataSecurityDesc: '我們採取多重安全措施保護您的資料：',
  dataSecurityItem1: '加密傳輸和儲存',
  dataSecurityItem2: '定期安全審核',
  dataSecurityItem3: '嚴格的存取控制',
  dataSecurityItem4: '員工培訓和保密協議',
  dataSecurityItem5: '及時的安全更新',
  dataSecurityNote: '雖然我們盡力保護您的資料，但沒有任何系統是 100% 安全的。',
  dataSharingTitle: '資訊分享',
  dataSharingDesc: '我們不會出售您的個人資訊。我們可能在以下情況下分享資訊：',
  dataSharingItem1: '經您同意後',
  dataSharingItem2: '與服務提供商（如雲端儲存）',
  dataSharingItem3: '遵守法律要求',
  dataSharingItem4: '保護我們的權利和安全',
  yourRightsTitle: '您的權利',
  yourRightsDesc: '您對您的個人資訊擁有以下權利：',
  yourRightsItem1: '存取您的資料',
  yourRightsItem2: '更正不正確的資料',
  yourRightsItem3: '刪除您的資料',
  yourRightsItem4: '限制資料處理',
  yourRightsItem5: '資料可攜性',
  yourRightsItem6: '反對資料處理',
  yourRightsNote: '要行使這些權利，請聯絡我們的支援團隊。',
  dataRetentionTitle: '資料保留',
  dataRetentionDesc: '我們保留您的資料的時間取決於：',
  dataRetentionItem1: '您的帳戶處於活躍狀態',
  dataRetentionItem2: '提供服務所需',
  dataRetentionItem3: '法律或監管要求',
  dataRetentionItem4: '解決爭議和執行協議',
  dataRetentionNote: '您可以隨時刪除您的帳戶和資料。',
  cookiesTitle: 'Cookie 和追蹤技術',
  cookiesDesc: '我們使用 Cookie 和類似技術：',
  cookiesItem1: '記住您的偏好',
  cookiesItem2: '分析網站使用情況',
  cookiesItem3: '改善用戶體驗',
  cookiesNote: '您可以通過瀏覽器設定管理 Cookie 偏好。',
  childrensPrivacyTitle: '兒童隱私',
  childrensPrivacyDesc: '我們的服務不針對 13 歲以下的兒童。我們不會故意收集兒童的個人資訊。',
  internationalTransfersTitle: '國際資料傳輸',
  internationalTransfersDesc: '您的資料可能會被傳輸到您所在國家/地區以外的伺服器。我們確保適當的保護措施到位。',
  policyChangesTitle: '政策變更',
  policyChangesDesc: '我們可能會不時更新本隱私權政策。我們將通過電子郵件或平台通知您任何重大變更。',
  contactInfoTitle: '聯絡資訊',
  contactInfoDesc: '如果您對本隱私權政策有任何疑問，請聯絡我們：',
  contactEmail: '電子郵件',
  contactEmailValue: 'info@homy.hk',
  viewTerms: '查看服務條款',

  // TermsPage
  termsOfServiceTitle: '服務條款',
  termsOfServiceSubtitle: '使用我們服務的條款和條件',
  termsIntroTitle: '接受條款',
  termsIntro: '使用我們的服務即表示您同意這些條款。請仔細閱讀。',
  serviceDescriptionTitle: '服務說明',
  serviceDescriptionDesc: '寵物照護平台提供以下服務：',
  serviceDescriptionItem1: '寵物資訊管理',
  serviceDescriptionItem2: '健康記錄追蹤',
  serviceDescriptionItem3: '照護指示分享',
  serviceDescriptionItem4: '獸醫資訊儲存',
  serviceDescriptionItem5: '提醒和通知',
  userAccountTitle: '用戶帳戶',
  userAccountDesc: '要使用我們的服務，您需要：',
  userAccountItem1: '創建帳戶並提供準確資訊',
  userAccountItem2: '保護您的帳戶憑證',
  userAccountItem3: '對您帳戶下的活動負責',
  userAccountItem4: '通知我們任何未經授權的使用',
  userAccountItem5: '年滿 18 歲或獲得父母同意',
  userAccountNote: '您有責任維護帳戶安全。',
  userResponsibilitiesTitle: '用戶責任',
  userResponsibilitiesDesc: '使用我們的服務時，您同意：',
  userResponsibilitiesItem1: '提供準確和最新的資訊',
  userResponsibilitiesItem2: '遵守所有適用的法律',
  userResponsibilitiesItem3: '尊重其他用戶的權利',
  userResponsibilitiesItem4: '不濫用或誤用服務',
  userResponsibilitiesItem5: '備份您的重要資料',
  userResponsibilitiesItem6: '對您上傳的內容負責',
  prohibitedActivitiesTitle: '禁止活動',
  prohibitedActivitiesDesc: '您不得：',
  prohibitedActivitiesItem1: '違反任何法律或法規',
  prohibitedActivitiesItem2: '侵犯他人的權利',
  prohibitedActivitiesItem3: '上傳惡意軟體或病毒',
  prohibitedActivitiesItem4: '嘗試未經授權的存取',
  prohibitedActivitiesItem5: '干擾服務運作',
  prohibitedActivitiesItem6: '出售或轉讓您的帳戶',
  intellectualPropertyTitle: '智慧財產權',
  intellectualPropertyDesc: '我們的服務受智慧財產權法律保護：',
  intellectualPropertyItem1: '我們擁有平台的所有權利',
  intellectualPropertyItem2: '您保留對您內容的所有權',
  intellectualPropertyItem3: '您授予我們使用您內容的許可',
  intellectualPropertyItem4: '不得未經授權使用我們的商標',
  intellectualPropertyNote: '您上傳的內容仍屬於您，但您授予我們使用許可以提供服務。',
  dataOwnershipTitle: '資料所有權',
  dataOwnershipDesc: '關於您的資料：',
  dataOwnershipItem1: '您擁有您上傳的所有資料',
  dataOwnershipItem2: '您可以隨時匯出或刪除您的資料',
  dataOwnershipItem3: '我們不會聲稱擁有您的內容',
  dataOwnershipItem4: '刪除帳戶後，您的資料將被永久刪除',
  serviceAvailabilityTitle: '服務可用性',
  serviceAvailabilityDesc: '關於服務可用性：',
  serviceAvailabilityItem1: '我們努力保持服務運行，但不保證 100% 正常運行時間',
  serviceAvailabilityItem2: '可能會有計劃內或計劃外的停機',
  serviceAvailabilityItem3: '我們可能會隨時修改或停止服務',
  serviceAvailabilityItem4: '我們不對服務中斷造成的損失負責',
  disclaimerTitle: '免責聲明',
  disclaimerDesc: '我們的服務按"現狀"提供：',
  disclaimerItem1: '不保證服務無錯誤或不間斷',
  disclaimerItem2: '不保證結果的準確性',
  disclaimerItem3: '不提供獸醫或醫療建議',
  disclaimerItem4: '用戶應諮詢專業人士',
  disclaimerItem5: '我們不對用戶決定負責',
  limitationOfLiabilityTitle: '責任限制',
  limitationOfLiabilityDesc: '在法律允許的最大範圍內：',
  limitationOfLiabilityItem1: '我們不對任何間接損失負責',
  limitationOfLiabilityItem2: '我們的責任限於您支付的費用',
  limitationOfLiabilityItem3: '某些司法管轄區可能不允許這些限制',
  terminationTitle: '終止',
  terminationDesc: '關於帳戶終止：',
  terminationItem1: '您可以隨時關閉您的帳戶',
  terminationItem2: '我們可能因違規而暫停或終止帳戶',
  terminationItem3: '終止後，您的資料將被刪除',
  terminationItem4: '某些條款在終止後仍然有效',
  changestoTermsTitle: '條款變更',
  changestoTermsDesc: '我們可能會更新這些條款：',
  changestoTermsItem1: '我們會通知您重大變更',
  changestoTermsItem2: '繼續使用即表示接受新條款',
  changestoTermsItem3: '如果不同意，您應停止使用服務',
  governingLawTitle: '適用法律',
  governingLawDesc: '這些條款受以下法律管轄：',
  governingLawItem1: '適用香港法律',
  governingLawItem2: '爭議將在香港法院解決',
  governingLawItem3: '雙方放棄陪審團審判權',
  contactForTermsTitle: '聯絡我們',
  contactForTermsDesc: '如果您對這些條款有任何疑問，請聯絡我們：',
  contactForTermsEmail: 'info@homy.hk',
  viewPrivacy: '查看隱私權政策',
};